import { render, staticRenderFns } from "./channel-details.vue?vue&type=template&id=7141fa38&scoped=true"
import script from "./channel-details.vue?vue&type=script&lang=ts"
export * from "./channel-details.vue?vue&type=script&lang=ts"
import style0 from "./channel-details.vue?vue&type=style&index=0&id=7141fa38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7141fa38",
  null
  
)

export default component.exports